/* eslint-disable */
// Configurazione DI PRODUZIONE.
// Viene copiata in defaults.js dallo script scripts/preBuild.sh durante `npm run build`;
// il placeholder 20260714143248 viene sostituito con la data/ora del build.
export class Conf {
         static idempiereUrl = "https://idempiere.vitechsrl.it/";   // produzione

         static codiceDitta = 8;
         static windowTitle = "VITECH";

         static buildNo = "20260714143248";
       }
